<template>
  <el-card class="ranking-card">
    <div slot="header" class="ranking-header">
      <span>热销产品TOP20</span>
      <div class="ranking-actions">
        <el-input
            v-model="searchQuery"
            placeholder="在列表中搜索产品名称"
            prefix-icon="el-icon-search"
            size="small"
            style="width: 200px; margin-right: 10px;"
        ></el-input>
      </div>
    </div>

    <el-table
        :data="filteredProducts"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        @row-click="handleRowClick"
    >
      <el-table-column
          label="排名"
          width="80"
          align="center"
      >
        <template #default="{ $index }">
          <div class="rank-cell" :class="getRankClass($index + 1)">
            {{ $index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="产品信息"
          min-width="200"
      >
        <template #default="{ row }">
          <div class="product-info-cell">
            <el-image
                :src="row.picture"
                fit="cover"
                class="product-thumb"
                :preview-src-list="[row.picture]"
            ></el-image>
            <div class="product-details">
              <div class="product-name">{{ row.productName }}</div>
              <div class="product-meta">
                <span class="product-category">{{ row.productClassifyName }}</span>
                <span class="product-spec">{{ row.spec }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          prop="totalSales"
          label="销售量(箱)"
          width="120"
          align="center"
          sortable
      >
        <template #default="{ row }">
          {{ row.totalSales | formatNumber }}
        </template>
      </el-table-column>

      <el-table-column
          prop="totalAmount"
          label="销售额(元)"
          width="150"
          align="center"
          sortable
      >
        <template #default="{ row }">
          {{ row.totalAmount | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          prop="price"
          label="单价(元)"
          width="120"
          align="center"
          sortable
      >
        <template #default="{ row }">
          {{ row.price | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          label="操作"
          width="150"
          align="center"
      >
        <template #default="{ row }">
          <el-button type="primary" @click="openTrend(row.productId)">销售趋势</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ProductSalesTrendDrawer
        :product-id="selectedProductId"
        v-model="drawerVisible"
        @close="handleDrawerClose"
    />
  </el-card>

</template>

<script>
import ProductSalesTrendDrawer from"./ProductSalesTrend.vue";
export default {
  components: {
    ProductSalesTrendDrawer
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    alcoholType: {
      type: Array,
      default: () => []
    },
    products: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      drawerVisible: false,
      selectedProductId: null,
      searchQuery: ''
    }
  },
  computed: {
    filteredProducts() {
      return this.products.filter(item => {
        const matchesSearch = item.productName.toLowerCase().includes(this.searchQuery.toLowerCase())
        const matchesType = this.alcoholType.length === 0 || this.alcoholType.includes(item.productClassifyId)
        return matchesSearch && matchesType
      })
    }
  },
  methods: {
    handleDrawerClose() {
      this.drawerVisible = false
      this.selectedProductId = null
    },
    openTrend(productId) {
      this.selectedProductId = productId
      this.drawerVisible = true
    },
    getRankClass(rank) {
      if (rank === 1) return 'rank-gold'
      if (rank === 2) return 'rank-silver'
      if (rank === 3) return 'rank-bronze'
      return ''
    },
    handleRowClick(row) {
      this.$emit('row-click', row)
    }
  },
  filters: {
    formatNumber(value) {
      if (!value) return '0'
      return Number(value).toLocaleString()
    },
    formatCurrency(value) {
      if (!value) return '¥0'
      return '¥' + Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.ranking-card {
  border-radius: 8px;

  .ranking-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
  }

  .rank-cell {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 4px;
    margin: 0 auto;
    font-weight: bold;
    background-color: #f5f7fa;
    color: #606266;

    &.rank-gold {
      background-color: #fdf6ec;
      color: #e6a23c;
    }

    &.rank-silver {
      background-color: #f4f4f5;
      color: #909399;
    }

    &.rank-bronze {
      background-color: #f0f9eb;
      color: #67c23a;
    }
  }

  .product-info-cell {
    display: flex;
    align-items: center;
    cursor: pointer;

    .product-thumb {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
    }

    .product-details {
      flex: 1;
      min-width: 0;

      .product-name {
        font-weight: 500;
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .product-meta {
        display: flex;
        margin-bottom: 4px;

        .product-category {
          font-size: 12px;
          color: #909399;
          margin-right: 10px;
        }

        .product-spec {
          font-size: 12px;
          color: #606266;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ProductRankingTable.vue?ddd300a0